export enum EventRegistrationType {
  SelfRegistration = 'self_registration',
  RegistrationFee = 'registration_fee',
  ExternalAAA = 'external_aaa',
  ExternalAAPT = 'external_aapt',
}
